import { getDocumentLocation } from '@nike/ux-tread-dotcom-utils';

/**
 * Method for getting the hostname without effecting build processes. This method will allow for generating urls for the staging environment without polluting urls required for building.
 * @returns {string} hostname
 */

const getHostname = () => {
  return getDocumentLocation().hostname || '';
};

export default getHostname;
